var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 19.625V27.5938M25 6.26782C20.5198 10.5956 14.4701 13.25 7.8125 13.25C7.70672 13.25 7.60109 13.2494 7.49561 13.248C6.68729 15.7558 6.25 18.4352 6.25 21.2189C6.25 33.1009 14.2173 43.0848 25 45.9155C35.7827 43.0848 43.75 33.1009 43.75 21.2189C43.75 18.4352 43.3127 15.7558 42.5044 13.248C42.3989 13.2494 42.2933 13.25 42.1875 13.25C35.5299 13.25 29.4802 10.5956 25 6.26782ZM25 33.9688H25.0156V33.9847H25V33.9688Z",
    stroke: "#90CC61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.482bcae7974ab5613bed1870563b50f7.svg";
export { ForwardRef as ReactComponent };